const getAasIdShortAndTypeV3 = (assetId, registryurl, headers) => {
    return fetch(registryurl, {headers: headers})
    .then((response) => {
        if (response.ok) {
          return response;
        }
        throw new Error('Registry cannot be opened');
      })
      .then(res => res.json())
      .then(res => {
        var r = res.result.find(aas => {
            return aas?.globalAssetId === assetId
          });
        if(r === undefined){
            return {}
        }
        console.log("aas found");
        console.log(r);
        var ids = r.idShort;
        var kind = r.specificAssetIds.find(id => {
            return id.name.toLowerCase() === "assetkind"
          });
        if(kind === undefined){
        throw new Error('Cannot locate assetKind in specific asset IDs');
        }
        var k = kind.value
        return {idShort: ids, kind: k};
        });
}

const resolveSubmodelEndpointV3 = (registry, aasIdShort, submodelIdShort, headers) =>{
  return fetch(registry, {headers: headers})
  .then((response) => {
      if (response.ok) {
        return response;
      }
      throw new Error('Registry cannot be opened');
    })
    .then(res => res.json())
    .then(res => {
      var result = res.result.find(aas => {
          return aas?.idShort === aasIdShort
        })
      if(result === undefined){
          throw new Error('AAS ' + aasIdShort + ' cannot be located in registry');
      }

      var submodel = result.submodelDescriptors.find(submodelDesc => {
          return submodelDesc.idShort === submodelIdShort
      })
      if(result === undefined){
          throw new Error('Submodel ' + submodelIdShort + ' cannot be located in AAS');
      }
      return submodel.endpoints[0].protocolInformation.href;
    }
    );
}

const getIdShortWithinBomV3 = (assetId, referenceIdShort, registryUrl, bomSubmodelIdShort, headers) => {
  assetId = decodeURIComponent(assetId);
  return AASInterfaceV3.resolveSubmodelEndpointV3(registryUrl, referenceIdShort, bomSubmodelIdShort, headers)
  .then(result => {
        console.log(result);
          var endpoint = result;
          return fetch(result, {headers: headers})
          .then((response) => {
              if (response.ok) {
              return response;
              }
              throw new Error('Bom submodel endpoint cannot be called');
          })
          .then(res => res.json())
          .then(res => {
              //console.log(res);
              var r = res.submodelElements.find(sme => {
                  return sme.globalAssetId === assetId
              });
              if(r === undefined){
                  return({"endpoint": endpoint, "idShort": ""});
              }else{
                  return({"endpoint": endpoint, "idShort": r.idShort});
              }
          });
      });
}

const deleteAssetV3 = (submodelEndpoint, idShort, headers) => {
  return fetch(submodelEndpoint+"/submodel-elements/"+idShort, {
      method: 'DELETE',
      headers: headers
  })
}

const createAssetV3 = (submodelEndpoint, assetId, headers) =>{
  assetId = decodeURIComponent(assetId);
  console.log(submodelEndpoint);
  console.log(assetId);
  var newId = Date.now()
  // return fetch(submodelEndpoint+"/submodel-elements/"+newId+"?first=true", {
  return fetch(submodelEndpoint+"/submodel-elements?first=true", {
      method: 'POST',
      headers: Object.assign({
        'Content-type': 'application/json'
      },headers),
      body: `
        {
          "idShort": "`+newId+`",
          "semanticId": {
            "type": "ExternalReference",
            "keys": []
          },
          "embeddedDataSpecifications": [],
          "statements": [],
          "entityType": "SelfManagedEntity",
          "globalAssetId":  "`+assetId+`",
          "modelType": "Entity"
        }
      `
    })
}

const AASInterfaceV3 = {
  getAasIdShortAndTypeV3,
  getIdShortWithinBomV3,
  resolveSubmodelEndpointV3,
  deleteAssetV3,
  createAssetV3
};

export default AASInterfaceV3;